import ApiService from '../../../../../../services/ApiService'

export default {
  props: {
    filterProp: Object,
  },
  components: {},
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      page: 1,
      showChart: true,
      total: 0,
      totalPages: 1,
      pageSize: 7,
      costs: [],
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Setor',
          align: 'center',
          value: 'department',
        },
        {
          text: 'Custo por Peça',
          align: 'center',
          value: 'totalPieceCosts',
        },
        {
          text: 'Custo por Serviço Externo',
          align: 'center',
          value: 'totalServiceCosts',
        },
        {
          text: 'Custo por Contrato',
          align: 'center',
          value: 'totalContractCosts',
        },
        {
          text: 'Custo Mão-de-Obra Interna',
          align: 'center',
          value: 'totalEtapaCosts',
        },
        {
          text: 'Custo Total',
          align: 'center',
          value: 'total',
        },
      ],
    }
  },
  async created() {
    this.listCostPerDepartment()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `cost_Per_Sector_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/costPerSector', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listCostPerDepartment() {
      this.loading = true
      await this.apiService
        .post('reports/listCostsDepartment', this.filterProp)
        .then((response) => {
          this.costs = []
          this.total = response.content.totalCosts
          this.showChart = response.content.objects.length > 0
          this.costs = response.content.objects
          this.totalPages = response.content.pager.totalPages
          this.loading = false
        })
        .catch((err) => {
          this.loading = false
        })
    },
    formatCurrency(value) {
      const stringValue = value.toFixed(2)
      const parts = stringValue.split('.')
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      return `$${parts.join(',')}`
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listCostPerDepartment()
    },
  },
}
